import { paths } from '@mc/paths'
import { track, getPageSource } from '@mc/track-event'

import { AnyCourse } from './types'

// Event Types
const TRAILER_MODAL_CLICK = 'Trailer Modal Click'
const TRAILER_MODAL_VIEWED = 'Trailer Modal Viewed'
const NEXT_TRAILER_VIEWED = 'Next Trailer Viewed'

// Actions
const VIEW_CLASS_INFO = 'View Class Info'
const VIEW_NEXT_TRAILER = 'View Next Trailer'
const EXIT = 'exit'

// Locations
const NEW_TRAILER_MODAL = 'new_trailer_modal'

// Helpers
const getPagePath = () =>
  typeof window !== 'undefined' ? window.location.pathname : ''

// Event trackers
export const trackViewClassClick = ({ course }: { course: AnyCourse }) => {
  track(TRAILER_MODAL_CLICK, {
    action: VIEW_CLASS_INFO,
    uuid: course.id,
    link: paths.courseTypePage(course.type, course.slug),
    location: NEW_TRAILER_MODAL,
    class: course.slug,
    page_source: getPageSource(),
    page_path: getPagePath(),
  })
}

export const trackRecommendationCarouselItemClick = ({
  course,
  trailerPositionIndex,
  totalNumberOfTrailers,
}: {
  course: AnyCourse
  trailerPositionIndex: number
  totalNumberOfTrailers: number
}) => {
  track(TRAILER_MODAL_CLICK, {
    action: VIEW_NEXT_TRAILER,
    uuid: course.id,
    link: paths.courseTypePage(course.type, course.slug),
    location: NEW_TRAILER_MODAL,
    class: course.slug,
    page_source: getPageSource(),
    page_path: getPagePath(),
    trailer_position_index: trailerPositionIndex,
    total_number_of_trailers: totalNumberOfTrailers,
  })
}

export const trackRecommendationFeedItemFocus = ({
  course,
  trailerPositionIndex,
  totalNumberOfTrailers,
}: {
  course: AnyCourse
  trailerPositionIndex: number
  totalNumberOfTrailers: number
}) => {
  track(TRAILER_MODAL_CLICK, {
    action: VIEW_NEXT_TRAILER,
    uuid: course.id,
    link: paths.courseTypePage(course.type, course.slug),
    location: NEW_TRAILER_MODAL,
    class: course.slug,
    page_source: getPageSource(),
    page_path: getPagePath(),
    trailer_position_index: trailerPositionIndex,
    total_number_of_trailers: totalNumberOfTrailers,
  })
}

export const trackNextTrailerViewed = ({
  trailerWatchCount,
  courseSlug,
}: {
  trailerWatchCount: number
  courseSlug: string
}) => {
  track(NEXT_TRAILER_VIEWED, {
    location: NEW_TRAILER_MODAL,
    page_source: getPageSource(),
    page_path: getPagePath(),
    count: trailerWatchCount,
    class: courseSlug,
  })
}

export const trackTrailerModalViewed = ({
  courseSlug,
  location = NEW_TRAILER_MODAL,
}: {
  courseSlug?: string
  location?: string
}) => {
  track(TRAILER_MODAL_VIEWED, {
    location,
    page_source: getPageSource(),
    class: courseSlug,
    page_path: getPagePath(),
  })
}

export const trackTrailerModalClose = ({ course }: { course: AnyCourse }) => {
  track(TRAILER_MODAL_CLICK, {
    action: EXIT,
    location: NEW_TRAILER_MODAL,
    uuid: course.id,
    link: paths.courseTypePage(course.type, course.slug),
  })
}
